import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { useFormContext } from 'react-hook-form';
import { useTracking } from '@PetSureAustralia/petsure-react-ui-library/distLib/hooks';
import { ValidationPropType } from '@PetSureAustralia/petsure-react-ui-library/distLib/propTypes';
import { PetDetailsPropTypes, PolicyDetailsPropTypes } from '../../propTypes/petDetails';
import { PetIcon } from '../petIcon/petIcon';
import { CSPUrlsMap } from '../../routes/CSPUrlsMap';

export const PetDetailRadio = ({
  fieldFormContext,
  petDetail,
  policyDetails,
  groupName,
  onChange,
  isChecked = false,
  isOnlyOption = false,
  isIconOnly = false,
  isReadOnly = false,
  customTrackingData,
  customTrackingEvents,
  validation,
  ...rest
}) => {
  const hookFormContext = useFormContext();
  const formContext = fieldFormContext || hookFormContext;
  const { register } = formContext || {
    register: () => {
      return { ref: () => {} };
    }
  };
  const fieldElement = useRef(null);

  const handleRadioSelect = (selectedValue) => {
    if (onChange) {
      onChange(selectedValue);
    }
  };

  const { PolicyNumber, FullPolicyNumber, Name, Species, PetProfilePicture } = petDetail;

  const { PetGender } = policyDetails;

  useTracking({
    elementRef: fieldElement,
    trackingProps: {
      label: `Pet ${Name} radio button`,
      field: {
        fieldState: (formContext && formContext.getFieldState(groupName)) || {},
        inputType: 'radio',
        name: groupName,
        id: PolicyNumber
      }
    },
    customTrackingData,
    customTrackingEvents
  });

  const { ref: hookFormRef, ...hookFormRegistration } = register(groupName, { ...validation });

  return (
    <label className={`radioInput petDetailsRadio petDetailsRadio_${PetGender} ${isChecked ? 'isChecked' : ''}`}>
      <input
        onClick={() => handleRadioSelect(FullPolicyNumber)}
        type="radio"
        defaultValue={FullPolicyNumber}
        defaultChecked={isChecked || isOnlyOption}
        disabled={isOnlyOption}
        name={groupName}
        id={PolicyNumber}
        readOnly={isReadOnly}
        {...hookFormRegistration}
        ref={(e) => {
          hookFormRef(e);
          fieldElement.current = e;
        }}
        {...rest}
      />

      <span className="labelText">
        <PetIcon
          profilePic={PetProfilePicture}
          fullPolicyNumber={FullPolicyNumber}
          gender={PetGender}
          species={Species}
          isChecked={isChecked}
        />
        {isIconOnly ? (
          <span className="petName">{Name}</span>
        ) : (
          <span className="petDetails">
            <strong>{Name}</strong>
            <span className="policyNumber">
              <small>Policy No.</small>
              {FullPolicyNumber}
            </span>
            <a
              rel="noreferrer"
              className="seeDetailsLink"
              href={`${CSPUrlsMap.myPets.url}?policy=${PolicyNumber}`}
            >
              See details
              <span className="sr-only">about {Name}&rsquo;s policy</span>
            </a>
          </span>
        )}
      </span>
    </label>
  );
};

PetDetailRadio.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  fieldFormContext: PropTypes.any,
  groupName: PropTypes.string,
  petDetail: PropTypes.shape(PetDetailsPropTypes),
  policyDetails: PolicyDetailsPropTypes,
  onChange: PropTypes.func,
  isChecked: PropTypes.bool,
  isOnlyOption: PropTypes.bool,
  isIconOnly: PropTypes.bool,
  isReadOnly: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  customTrackingData: PropTypes.any,
  customTrackingEvents: PropTypes.arrayOf(PropTypes.string),
  validation: PropTypes.shape(ValidationPropType)
};
